module.exports = __webpack_public_path__ + "fonts/fa-solid-900.e8a427e1.woff2";